import { useSnapshot } from 'valtio';

import Dropdown from '@cartwhl/ui/atoms/Dropdown';
import Text from '@cartwhl/ui/base/Text';
import CameraIcon from '@cartwhl/ui/icons/CameraIcon';
import ChevronDropdownIcon from '@cartwhl/ui/icons/ChevronDropdownIcon';
import KeyboardIcon from '@cartwhl/ui/icons/KeyboardIcon';
import SearchIcon from '@cartwhl/ui/icons/SearchIcon';

import { uiStore } from 'stores';

export default function FrontDoorDropdown() {
  const { motionFrontDoorMode } = useSnapshot(uiStore.state);

  // Get the current active option text
  const getCurrentText = () => {
    switch (motionFrontDoorMode) {
      case 'video':
        return 'Video to animation';
      case 'existing':
        return 'Search Motion Library';
      case 'text':
        return 'Text to animation';
      default:
        return 'Create motion';
    }
  };

  const getCurrentIcon = () => {
    switch (motionFrontDoorMode) {
      case 'video':
        return <CameraIcon className="text-gray-90 relative bottom-px" />;
      case 'existing':
        return <SearchIcon className="text-gray-90 relative bottom-px" />;
      case 'text':
        return <KeyboardIcon className="text-gray-90 relative bottom-px" />;
      default:
        return null;
    }
  };

  return (
    <Dropdown
      trigger={
        <button className="flex h-10 w-full items-center justify-between rounded-lg bg-white/55 pr-4 pl-3 text-left transition-colors hover:bg-gray-50">
          <div className="flex items-center gap-2">
            {getCurrentIcon()}
            <Text variant="studio/body/medium/sm" className="text-gray-90">
              {getCurrentText()}
            </Text>
          </div>
          <ChevronDropdownIcon className="text-gray-60 rotate-180" />
        </button>
      }
      align="end"
      side="top"
      width={328}
    >
      <Dropdown.Item
        icon={<CameraIcon className="relative bottom-px" />}
        onClick={() => {
          if (motionFrontDoorMode === 'video') {
            uiStore.setMotionFrontDoorMode('');
          } else {
            uiStore.setMotionFrontDoorMode('video');
          }
        }}
        variant={motionFrontDoorMode === 'video' ? 'blue' : 'default'}
      >
        Video to animation
      </Dropdown.Item>
      <Dropdown.Item
        icon={<SearchIcon className="relative bottom-px" />}
        onClick={() => {
          if (motionFrontDoorMode === 'existing') {
            uiStore.setMotionFrontDoorMode('');
          } else {
            uiStore.setMotionFrontDoorMode('existing');
          }
        }}
        variant={motionFrontDoorMode === 'existing' ? 'blue' : 'default'}
      >
        Search Motion Library
      </Dropdown.Item>
      <Dropdown.Item
        icon={<KeyboardIcon className="relative bottom-px" />}
        onClick={() => {
          if (motionFrontDoorMode === 'text') {
            uiStore.setMotionFrontDoorMode('');
          } else {
            uiStore.setMotionFrontDoorMode('text');
          }
        }}
        variant={motionFrontDoorMode === 'text' ? 'blue' : 'default'}
      >
        <div className="flex w-full min-w-[255px] flex-1 items-center justify-between gap-2">
          <span>Text to animation</span>
        </div>
      </Dropdown.Item>
    </Dropdown>
  );
}
